// Register each file as a corresponding Vuex module. Module nesting
// will mirror [sub-]directory hierarchy and modules are namespaced
// as the camelCase equivalent of their file name.

import camelCase from 'lodash/camelCase'

// https://vite.dev/guide/features#glob-import
const moduleFiles = import.meta.glob(
    [
        // Any .js file in this directory or a subdirectory of it...
        './**/*.js',
        // ...that is neither a unit test nor this file
        '!./**/*.unit.js',
        '!./index.js',
    ],
    { eager: true }
)
const root = { modules: {} }

Object.entries(moduleFiles).forEach(([fileName, vuexModule]) => {
    // Get the module path as an array
    const modulePath = fileName
        // Remove the "./" from the beginning
        .replace(/^\.\//, '')
        // Remove the file extension from the end
        .replace(/\.\w+$/, '')
        // Split nested modules into an array path
        .split(/\//)
        // camelCase all module namespaces and names
        .map(camelCase)

    // Get the modules object for the current path
    const { modules } = getNamespace(root, modulePath)

    // Add the module to our modules object
    modules[modulePath.pop()] = {
        // Modules are namespaced by default
        namespaced: true,
        ...vuexModule,
    }

    // Recursively get the namespace of the module, even if nested
    function getNamespace(subtree, path) {
        if (path.length === 1) return subtree

        const namespace = path.shift()
        subtree.modules[namespace] = { modules: {}, ...subtree.modules[namespace] }
        return getNamespace(subtree.modules[namespace], path)
    }
})

export default root.modules
